import * as React from "react";
import { Table, Typography } from "antd";
import { IRelativeWorkingInCourt } from "../../../../model/report/applicantdata/RelativeWorkingInCourt";

const RelativeWorkingInCourtGrid = ({
  translate,
  data
}: {
  translate?: any;
  data?: IRelativeWorkingInCourt[];
  title?: string;
}) => {
  const columns = [
    {
      title: translate(
        "report8.document_template.relatives_working_in_court.name"
      ),
      dataIndex: "relativesName",
      key: "relativesName"
    },
    {
      title: translate(
        "report8.document_template.relatives_working_in_court.relation"
      ),
      dataIndex: "relation",
      key: "relation"
    },
    {
      title: translate(
        "report8.document_template.relatives_working_in_court.work_place"
      ),
      dataIndex: "workPlace",
      key: "workPlace"
    },
    {
      title: translate(
        "report8.document_template.relatives_working_in_court.function"
      ),
      dataIndex: "function",
      key: "function"
    }
  ];
  return (
    <div>
      <Typography.Title style={{ fontSize: 12, marginBottom: 20 }}>
        {translate(
          "report8.document_template.relatives_working_in_court.title"
        )}
      </Typography.Title>
      <Table
        style={{ marginBottom: 15 }}
        bordered
        dataSource={data}
        columns={columns}
        pagination={false}
        size={"small"}
        locale={{ emptyText: translate("reports.table.no_data") }}
      />
    </div>
  );
};

export default RelativeWorkingInCourtGrid;
